export class Doctor {
  /**
   * @param {number} id
   * @param {string} avatar
   * @param {string} phone
   * @param {string} email
   * @param {string} login
   * @param {string} nickname
   * @param {string} lastName
   * @param {string} firstName
   * @param {string} middleName
   * @param {string} fullAddress
   * @param {string} address
   * @param {number} passportNumber
   * @param {number} passportSeries
   * @param {number} sex
   * @param {string} licenseDate
   * @param {string} licenseNumber
   * @param {{ startWorkTime: number; endWorkTime: number; interval: number }} workSettings
   * @param {string} cityCode
   * @param {string} streetCode
   * @param {number} scientificDegree
   * @param {number} education
   * @param {number} rating
   * @param {number} reviewsCount
   * @param {string} preferredLanguage
   * @param {string} country
   * @param {number} acquainted
   * @param {Object} schedule
   */
  constructor({
    id,
    avatar,
    phone,
    email,
    login,
    nickname,
    lastName,
    firstName,
    middleName,
    fullAddress,
    address,
    passportNumber,
    passportSeries,
    sex,
    licenseDate,
    licenseNumber,
    workSettings,
    cityCode,
    streetCode,
    scientificDegree,
    education,
    rating,
    reviewsCount,
    preferredLanguage,
    country,
    acquainted,
    schedule,
    specializations,
  }) {
    this.id = id;
    this.avatar = avatar;
    this.phone = phone;
    this.email = email;
    this.login = login;
    this.nickname = nickname;
    this.lastName = lastName;
    this.firstName = firstName;
    this.middleName = middleName;
    this.fullAddress = fullAddress;
    this.address = address;
    this.passportNumber = passportNumber ? Number(passportNumber) : 0;
    this.passportSeries = passportSeries ? Number(passportSeries) : 0;
    this.sex = sex ? Number(sex) : 0;
    this.licenseDate = licenseDate;
    this.licenseNumber = licenseNumber;
    this.workSettings = workSettings;
    this.cityCode = cityCode;
    this.streetCode = streetCode;
    this.scientificDegree = scientificDegree ? Number(scientificDegree) : 0;
    this.education = education ? Number(education) : 0;
    this.rating = rating ? Number(rating) : 0;
    this.reviewsCount = reviewsCount ? Number(reviewsCount) : 0;
    this.preferredLanguage = preferredLanguage;
    this.country = country;
    this.acquainted = acquainted ? Number(acquainted) : 0;
    this.schedule = schedule;
    this.specializations = specializations;
  }

  /**
   * @returns {string}
   */
  get fullName() {
    return `${this.lastName} ${this.firstName} ${this.middleName}`;
  }
}
